import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IFeedsConfigurationProvider, IValidationErrorResponse, Module, NewsRssFeedType, Provider, ValidationModule, ValidationType } from '@bciti/types';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs/operators';
import { ValidatorService } from 'src/app/services/validator/validator.service';

export interface IRssProviderDialogUpdateEvent {
    old: IFeedsConfigurationProvider | undefined;
    new: IFeedsConfigurationProvider;
}

export interface IRssProviderDialogData {
    type: Provider;
    url?: string;
}

@Component({
    selector: 'app-rss-provider-dialog',
    templateUrl: './rss-provider-dialog.component.html',
    styleUrls: ['./rss-provider-dialog.component.scss'],
})
export class RssProviderDialogComponent implements OnInit {
    form: FormGroup;

    @Output() update = new EventEmitter<IRssProviderDialogUpdateEvent>();

    loading = false;
    validated = false;
    results: IValidationErrorResponse[] = [];

    constructor(
        private dialogRef: MatDialogRef<RssProviderDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: IRssProviderDialogData,
        private fb: FormBuilder,
        private validatorService: ValidatorService,
        private toastService: ToastrService,
    ) {}

    ngOnInit(): void {
        this.form = this.fb.group({
            url: new FormControl(this.data.url ?? '', [Validators.required]),
            newsRssFeedType: new FormControl(''),
        });
    }

    validateFeed() {
        if (this.form.valid) {
            this.results = [];
            this.loading = true;
            this.validated = false;
            this.validatorService
                .validateRssFromUrl(ValidationType.RSS, this.validationModule, this.form.get('url').value, this.form.get('newsRssFeedType')?.value)
                .pipe(take(1))
                .subscribe(
                    (res) => {
                        this.results = res;
                        this.loading = false;
                        this.validated = true;
                    },
                    (error) => {
                        this.results = [];
                        this.loading = false;
                        this.validated = false;
                        this.toastService.error(error.error.message, `${error.error.statusCode}: ${error.error.error}`);
                    },
                );
        }
    }

    close() {
        this.dialogRef.close();
    }

    submit() {
        if (this.form.valid) {
            this.update.emit({
                old: this.data.url ? (this.data as IFeedsConfigurationProvider) : undefined,
                new: {
                    type: this.data.type,
                    url: this.form.get('url').value,
                },
            });

            this.close();
        }
    }

    get validationModule() {
        switch (this.data.type) {
            case Provider.NEWS:
                return ValidationModule.News;
            default:
                return ValidationModule.Calendar;
        }
    }

    get buttonText() {
        return !!this.data.url ? 'Update' : 'Add';
    }

    get availableNewsRssFeedTypes() {
        return Object.values(NewsRssFeedType);
    }
}
